// extracted by mini-css-extract-plugin
export default {"container":"FooterButtonCreateCampaign_container__fJqL0"};